import "./StoreOtherDetails.scss";
import { Render } from "../../../../../../../../homepage/Render";

export const StoreOtherDetails = (props) => {
  const { packageData } = props;

  return (
    <Render if={packageData?.length > 0}>
      <div className="other-details-inner-wrapper">
        <h3>Other details</h3>
        <ul>
          {packageData?.map((item, index) => (
            <li key={index}>{item.name}</li>
          ))}
        </ul>
      </div>
    </Render>
  );
};
